<div class="flex flex-col flex-auto md:w-160 md:min-w-160 max-h-160 -m-6 overflow-y-auto">

	<!-- Header -->
	<div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-accent text-on-primary">
		<div class="text-lg font-medium">Edit User</div>
		<button (click)="cancel()" mat-icon-button [tabIndex]="-1">
			<mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
		</button>
	</div>

	<div class="flex flex-col gap-4 p-6">

		<form [formGroup]="editForm" class="grid grid-cols-2 gap-4">

			<mat-form-field>
				<mat-label>First Name</mat-label>
				<input matInput formControlName="firstName" placeholder="Enter first name">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Last Name</mat-label>
				<input matInput formControlName="lastName" placeholder="Enter last name">
			</mat-form-field>

			<mat-form-field class="col-span-2">
				<mat-label>Email</mat-label>
				<input matInput type="email" formControlName="email" placeholder="Enter email">
				<mat-error *ngIf="editForm.get('email')?.hasError('email')">
					Please enter a valid email address
				</mat-error>
			</mat-form-field>

		</form>

		<div class="flex gap-4 justify-between mt-8">

			<button mat-stroked-button (click)="cancel()">Cancel</button>
			<button mat-raised-button color="primary" (click)="save()" [disabled]="editForm.invalid || saving">
				<span *ngIf="!saving">Save Changes</span>
				<span *ngIf="saving" class="flex items-center gap-2">
					<div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
					Saving...
				</span>
			</button>
		</div>

	</div>

</div>
